export var Features = /*#__PURE__*/ function (Features) {
    Features["Test"] = "test_frontend";
    Features["DisabledFeatureTest"] = "disabled_feature_test";
    Features["LinkCreationWithExpiration"] = "51b703da-4f0a-4430-80a0-208cd6f57558";
    Features["PasswordValidation"] = "Gp3Xv7kLq4nB9Z2R";
    Features["MembersRedesign"] = "M4p7D2x9R1v6T8c3ALP";
    Features["ServersRedesign"] = "Z3n8wH1Q5t9B2k7LALP";
    Features["ActivityRedesign"] = "k4N7bX2pQ9mR6tVALP";
    Features["UsersManagement"] = "a9B3k7Z2p4Q8x6M1INT";
    Features["Distributors"] = "a7G9K3tB5xQ2mZ8NALP";
    Features["NBMMigration"] = "DW6qVQmYgfyhnt4dJ4BOB";
    Features["MspPartnersRedesign"] = "wy6uQMOlHHpJw3aIINT";
    Features["RefundsRedesign"] = "pqNK31E6ex4GrVDPtsBOB";
    Features["OrdersRedesign"] = "5YhbAQc9EqvQWeUerKBOB";
    Features["MultiProductProductsPage"] = "K7qN4zR8wM2xE9cB1aBOB";
    Features["PackageProductSelection"] = "xDJhUw8Gfg8S1nAbeP5XBOB";
    Features["PlanProductSelection"] = "sVkrF5Tmt4YZU5Fg4VNABOB";
    Features["PackagesListRedesign"] = "pcA5k6kzcN8ffmjYebGTBOB";
    Features["MonetizationSettingsPage"] = "yd6E61SHHkPBzKsSQBOB";
    Features["MultiRegionSwitcher"] = "ldEx9HmGnrIj698CINT";
    Features["CouponPartialEdit"] = "Rqf4BEu5AjkrEXvtnBOB";
    Features["OrganizationsRedesign"] = "IX1i4YF6uH5XOtVINT";
    return Features;
}({});
